<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="cip">© 2011 by Kelly Long</p>
<p class="cip">All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.</p>
<p class="cip">Published in Nashville, Tennessee, by Thomas Nelson. Thomas Nelson is a registered trademark of Thomas Nelson, Inc.</p>
<p class="cip">Thomas Nelson, Inc., books may be purchased in bulk for educational, business, fund-raising, or sales promotional use. For information, please e-mail SpecialMarkets@ ThomasNelson.com.</p>
<p class="cip">Scripture quotations are from the King James Version of the Holy Bible.</p>
<p class="cip">Publisher’s Note: This novel is a work of fiction. Names, characters, places, and incidents are either products of the author’s imagination or used fictitiously. All characters are fictional, and any similarity to people living or dead is purely coincidental.</p>
<p class="cip">ISBN 978-1-4016-8941-4 (eBook)</p>
<p class="cip">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Long, Kelly.</p>
<p class="cip">  An Amish wedding / Kelly Long, Kathleen Fuller, Beth Wiseman.</p>
<p class="cip">       p. cm.</p>
<p class="cip">  ISBN 978-1-59554-921-1 (trade paper)</p>
<p class="cip">1.  Amish—Fiction. 2.  Christian fiction, American. 3.  Love stories, American.  I. Fuller, Kathleen. II. Wiseman, Beth, 1962- III. Title.</p>
<p class="cip">  PS648.A45L68 2011</p>
<p class="cip">  813'.6—dc23	   2011035347</p>
<p class="cip"><em class="i">Printed in the United States of America</em></p>
<p class="cip">11 12 13 14 15 QG 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// APerfectSecreteBook1.vue?af24b14c